import { render, staticRenderFns } from "./QuotedAboveTarget.vue?vue&type=template&id=a98cd2c8"
import script from "./QuotedAboveTarget.vue?vue&type=script&lang=js"
export * from "./QuotedAboveTarget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports